import CryptoJS from 'crypto-js'

export const cryptoKey: string = import.meta.env.VITE_CRYPTO_KEY

/**
 * AES 加密函数
 * @param data 要加密的数据
 * @param key 加密密钥
 * @returns 加密后的 Base64 字符串
 */
export const encryptAES = (data: string, key: string): string => {
    const dataBytes = CryptoJS.enc.Utf8.parse(data)
    const keyBytes = CryptoJS.enc.Utf8.parse(key || cryptoKey)
    const encrypted = CryptoJS.AES.encrypt(dataBytes, keyBytes, {
        iv: keyBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

/**
 * AES 解密函数
 * @param data 要解密的 Base64 字符串
 * @param key 解密密钥，可选，默认使用 cryptoKey
 * @returns 解密后的字符串
 */
export const decryptAES = (data: string, key?: string): string => {
    const keyBytes = CryptoJS.enc.Utf8.parse(key || cryptoKey)
    const decrypted = CryptoJS.AES.decrypt(data, keyBytes, {
        iv: keyBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })

    return CryptoJS.enc.Utf8.stringify(decrypted)
}
